import config from '../../config'
import {
  valid,
  refreshToken,
  ajax,
  serviceAjax,
  header
} from './base'

const order = {

  async GetHeadOrganization(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Organization/GetHeadOrganization',
      type: 'get',
      data
    })
    return response
  },
  // 订单规则
  async GetOrderRuleList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderRule/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetOrderRule(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderRule/GetById',
      type: 'get',
      data
    })
    return response
  },
  async UpdateOrderRule(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderRule/Update',
      type: 'post',
      data
    })
    return response
  },
  // 订单
  async GetOrderMasterList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetDeliveryOrderList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DeliveryOrder/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetDeliveryOrder(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DeliveryOrder/GetDeliveryOrder',
      type: 'get',
      data
    })
    return response
  },
  async GetOrderMasterExportList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/GetExportPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetOrderMasterAuditList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/GetAuditPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/GetById',
      type: 'get',
      data
    })
    return response
  },
  async CreateOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/Create',
      type: 'post',
      data
    })
    return response
  },
  async UpdateOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/Update',
      type: 'post',
      data
    })
    return response
  },
  async SubmitOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/Submit',
      type: 'post',
      data
    })
    return response
  },
  async SubmitOrderToErp(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/SubmitToErp',
      type: 'post',
      data
    })
    return response
  },
  async UnAuditOrder(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/UnAudit',
      type: 'post',
      data
    })
    return response
  },
  async AuditOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/Audit',
      type: 'post',
      data
    })
    return response
  },
  async UpdateOrderItem(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/UpdateOrderItem',
      type: 'post',
      data
    })
    return response
  },
  async CancelOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/Cancel',
      type: 'post',
      data
    })
    return response
  },
  async DeleteOrderMaster(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/OrderMaster/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetAllDealerGroups(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/GetAllForCascader',
      type: 'get',
      data
    })
    return response
  },
  async GetAllDepartmentData(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Department/GetAllDepartmentForCascader',
      type: 'get',
      data
    })
    return response
  },

}
export default order



// WEBPACK FOOTER //
// ./src/common/api/order.js